module.exports = __webpack_public_path__ + "img/menu.729b0cf4.svg";